import styled from 'styled-components'

export const FloatingContainer = styled.div`
  bottom: 0;
  left: 0;
  padding-bottom: 16px;
  position: fixed;
  right: 0;
  text-align: center;
  z-index: ${o => o.theme.zIndex.foregroundContent};
`

export const ButtonsWrapper = styled.div`
  align-items: center;
  background-color: ${o => o.theme.color.deprecated.obsidian};
  border-radius: 5px;
  display: inline-flex;
  flex-wrap: nowrap;
`

export const GroupButton = styled.button`
  align-items: center;
  color: white;
  display: inline-flex;
  font-size: 14px;
  font-weight: 700;
  outline: none;
  padding: 10px 12px;

  &:first-child {
    padding-left: 18px;
  }

  &:last-child {
    padding-right: 18px;
  }
`

export const Divider = styled.div`
  background-color: white;
  display: inline-block;
  height: 18px;
  width: 1px;
`
